import './styles/fonts.css'
import './styles/global.css'
import './styles/games.css'
import { createApp } from './app'
import { lockChrome } from './input/lock-chrome'

lockChrome()

const root = document.getElementById('app')
if (!root) throw new Error('Missing #app')
createApp(root)
